import { jsx as _jsx } from "react/jsx-runtime";
import { Z3kSecondRoutes } from 'z3k-settings/routes/type';
import { unpack_validation } from 'z3k-parser/validation/types';
import { Z3kDragDropContainer } from '../utils/drag-drop-drawer/container';
export function InterfaceSettings() {
    const customButtons = [
        Z3kSecondRoutes.heating_interface,
        Z3kSecondRoutes.ui_system_group,
    ];
    const findId = (item_key, item_id, findInConfig) => {
        return ((!item_id || !findInConfig) &&
            item_key != Z3kSecondRoutes.heating_interface &&
            item_key != Z3kSecondRoutes.ui_system_group);
    };
    return _jsx(Z3kDragDropContainer, { findId: findId, customButtons: customButtons });
}
const fields = [];
InterfaceSettings.isError = (validation_result) => fields.reduce((prev, current) => prev || !!unpack_validation(validation_result, current), false);
InterfaceSettings.isWarning = (validation_result, service_view) => {
    if (!service_view) {
        return false;
    }
    return fields.reduce((prev, current) => prev || !!unpack_validation(validation_result, current), false);
};
InterfaceSettings.isShown = (is_service_view, config, spec, is_staff, is_climatic) => spec.heating.has_heating && is_service_view && !is_climatic;
